export default __webpack_public_path__ + "static/media/generalViewDoubleWithSecondaryDrain.8afab3e6.png";